import React from 'react';
import { createCustomEvent } from '@/util/createCustomEvent';
import { SCROLL } from '@/constants/custom-event-names';
import css from '@/css/module/new-world.css';
import {
  useHeadings_LEGACY,
  useLoadRows_LEGACY,
} from '@/features/query-builder/hooks/LEGACY';
import { useAppSelector } from '@/store/hooks';
import { selectIsLoadingRows } from '@/features/query-builder/queryBuilderSlice';
import { useDrilldownError } from '@/features/drilldown/hooks';
import { DrilldownTable } from './components/DrilldownTable';
import { NoResults } from './components/NoResults';
import { Header } from './components/Header';
import { DrilldownProvider } from './context';

const updateScroller = () => {
  // keep scroller's width in sync with data-table
  $('.scroller').width($('.data-table').width());
  // set height big enough to see the scrollbar
  $('.scroller-holder').height(16);
  // but if there's no reason to show the scrollbar, then hide it again
  if (
    $('.scroller').width() <= $('.scroller-holder').width() || // nothing to scroll
    (navigator.platform.indexOf('Win') === -1 &&
      navigator.platform.indexOf('Linux') === -1)
  ) {
    // or, not using windows or Linux
    // hide scrollbar
    $('.scroller').width(1);
    $('.scroller-holder').height(1);
  }
};

const handleScroll = () => {
  window.dispatchEvent(createCustomEvent(SCROLL));
};

const Drilldown = () => {
  const { dataTable } = useLoadRows_LEGACY();
  const hasError = !!useDrilldownError();
  const headings = useHeadings_LEGACY();
  const isLoading = useAppSelector(selectIsLoadingRows);
  const fixedHeadersRef = React.useRef(null);

  React.useEffect(() => {
    updateScroller();
  }, [dataTable, headings]);

  if (hasError) return null;

  return (
    <div className={css.tableContainerInner} onScroll={handleScroll}>
      <div style={{ overflow: 'visible' }}>
        <Header headerRef={fixedHeadersRef} />
        <DrilldownProvider value={fixedHeadersRef}>
          <DrilldownTable
            isMainTable
            isLoading={isLoading}
            dataTable={dataTable}
          />
        </DrilldownProvider>
        {!isLoading && <NoResults />}
        {/* div below ensures some space between bottom of table and bottom bar */}
        <div className={css.buffer} />
      </div>
    </div>
  );
};

export default Drilldown;
